<ng-container *ngIf="!!page">
    <tt-card>
        <tt-input ttLabel="transportarea_name" [(ttModel)]="page.transportarea_name"></tt-input>
        <div class="tt-transport-area-menu__buttons">
            <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
            <tt-button ttText="delete" ttType="danger" ttIcon="fad fa-trash" (ttClick)="delete()" [ttLoading]="deleting"></tt-button>
        </div>
    </tt-card>
</ng-container>
<tt-grid *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>
